module.exports = __webpack_public_path__ + "img/Menu-06.e8d297b1.png";